import { render, staticRenderFns } from "./MinimalHeader.vue?vue&type=template&id=ab491186&scoped=true&"
import script from "./MinimalHeader.vue?vue&type=script&lang=js&"
export * from "./MinimalHeader.vue?vue&type=script&lang=js&"
import style0 from "./MinimalHeader.vue?vue&type=style&index=0&id=ab491186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab491186",
  null
  
)

export default component.exports